import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

export const Navigation: React.FC = () => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark' || (!saved && window.matchMedia('(prefers-color-scheme: dark)').matches);
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="nav-header">
      <nav className="nav-container">
        <NavLink to="/" className="nav-logo" onClick={closeMenu}>
          <span className="nav-logo-icon">🏆</span>
          <span className="nav-logo-text">Camera Trofeelor</span>
        </NavLink>

        <button
          className="nav-menu-toggle"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Închide meniul' : 'Deschide meniul'}
          aria-expanded={isMenuOpen}
          type="button"
        >
          <span className={`hamburger ${isMenuOpen ? 'open' : ''}`} />
        </button>

        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <NavLink to="/" className="nav-link" onClick={closeMenu}>
            Acasă
          </NavLink>
          <NavLink to="/plan" className="nav-link" onClick={closeMenu}>
            Plan 30 Zile
          </NavLink>
          <NavLink to="/trofee" className="nav-link" onClick={closeMenu}>
            Trofee
          </NavLink>
          <NavLink to="/joc" className="nav-link" onClick={closeMenu}>
            Mini-Joc
          </NavLink>
          <NavLink to="/generator" className="nav-link" onClick={closeMenu}>
            Generator AI
          </NavLink>
          <NavLink to="/setari" className="nav-link" onClick={closeMenu}>
            Setări
          </NavLink>
          <button
            className="nav-theme-toggle"
            onClick={toggleTheme}
            aria-label={isDark ? 'Schimbă la tema luminoasă' : 'Schimbă la tema întunecată'}
            type="button"
          >
            {isDark ? '☀️' : '🌙'}
          </button>
        </div>
      </nav>
    </header>
  );
};
